export default __webpack_public_path__ + "static/media/profile_placeholder.7d80cc39.png";